import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { UserAccountsService } from '../../common/user-accounts/user-accounts.service';
import { Validators } from '@angular/forms';

@Injectable({
    providedIn: 'root'
})
export class ProfileResolverService implements Resolve<any> {

    constructor(
        private profileService: UserAccountsService
    ) {
    }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
        return this.profileService.getProfile();
    }
}
